
import { defineComponent, ref, Ref } from 'vue'
import { Map, VectorLayer, Marker, Coordinate } from 'maptalks'
import AppHeader from '@/components/Header.vue'
import getMapSiteInfo from '@/compositions/map/index'
import { Search, Button } from 'vant'
import { useLocactionInfo } from '@/compositions/common'
import FaultPoints from '@/components/device-replace-v3/points.vue'
import { NetworkpointItem } from '@/types/fault'
import { useStore } from 'vuex'
import { getMap } from '@/utils/maptalkFactory'
import { UserLocationInfoStorage } from '@/storage/common'

import getCacheFaultBillInfo from '@/compositions/fault/device'

interface DrawElement {
  lat: number
  lng: number
  name: string
}
export default defineComponent({
  name: 'Fault-Networkpoints',
  components: {
    AppHeader,
    VanSearch: Search,
    FaultPoints,
    Button,
  },
  data() {
    return {
      pointData: {},
    }
  },
  setup() {
    const store = useStore()
    const box = ref<HTMLElement>()
    const keywords: Ref<string> = ref('')
    let _selectedItem: NetworkpointItem
    const rightCanClick: Ref<boolean> = ref(false)
    const { cacheFaultBill, cacheNetworkpoint } = getCacheFaultBillInfo()
    let { mapSite, mapZoom, mapCenter } = getMapSiteInfo()
    let _layer: VectorLayer = null
    let map: Map = null
    const { initNearbyWarehouseHandle, locationInfo } = useLocactionInfo()

    return {
      $store: store,
      mapSite,
      mapZoom,
      mapCenter,
      map,
      box,
      _layer,
      keywords,
      _selectedItem,
      cacheNetworkpoint,
      rightCanClick,
      cacheFaultBill,
      locationInfo,
      initNearbyWarehouseHandle,
    }
  },
  watch: {
    locationInfo(val) {
      if (!this.map && val?.lat && val?.lng) {
        UserLocationInfoStorage.set(val)
        this.mapCenter = [val.lng, val.lat]
        this.$nextTick(() => {
          this.initPageHandle()
        })
      }
    },
  },
  // 这个要写这里，写setup的onMounted会让map永远为null
  async mounted() {
    try {
      await this.initNearbyWarehouseHandle()
      // 成功获取后，hooks里会给locationInfo赋值
      console.log('loca', this.locationInfo)
    } catch (error) {
      console.log('error', error)
    }
  },
  beforeUnmount() {
    this.clearLayer()
    this.removeLayer()
    if (this.map) this.map.remove()
  },
  methods: {
    initPageHandle() {
      this.map = getMap(this.box, {
        center: this.mapCenter,
        zoom: this.mapZoom,
        attribution: false,
      })
      this.map.on('viewchange', () => {
        const mapView = this.map.getView()
        const { center, zoom } = mapView as { center: number[]; zoom: number }
        this.$store.commit('setMapSite', {
          center,
          zoom,
        })
      })
      this.$nextTick(() => {
        if (this.cacheNetworkpoint?.guid) {
          this.onSwitchPoint(this.cacheNetworkpoint)
        }
      })
    },
    onComfirmSelect() {
      sessionStorage.setItem('DeviceReplacePointerData', JSON.stringify(this.pointData))
      this.$router.go(-1)
    },
    clearLayer(): void {
      if (this._layer) this._layer.clear()
    },
    removeLayer(): void {
      if (this._layer) {
        this._layer.remove()
        this._layer = null
      }
    },
    onSwitchPoint(item: NetworkpointItem): void {
      this._selectedItem = item
      this.rightCanClick = !!item
      this.createLayer()
      this.clearLayer()
      const obj: DrawElement = {
        lat: item.lat,
        lng: item.lng,
        name: item.name,
      }
      this.pointData = item
      this.drawSite(obj)
    },
    createLayer(): void {
      if (!this._layer && this.map)
        this._layer = new VectorLayer(Date.now().toString()).addTo(this.map)
    },
    drawSite(item: DrawElement): void {
      if (!this._layer || !this.map) return
      const { lat, lng, name } = item
      const point: number[] = [lng, lat]
      const marker: Marker = new Marker(point, {
        id: Date.now().toString(),
        editable: false,
        interactive: false,
        symbol: {
          markerFile: '/images/icon_weizhi.png',
          markerWidth: 40,
          markerHeight: 40,
          scale: 1,
          textName: name,
          textFill: 'rgba(255,255,255,1)',
          textSize: 12,
          textWeight: 500,
          textHaloFill: '#222',
          textHaloRadius: 1,
          textHaloOpacity: 0.6,
        },
      })
      this._layer.addGeometry(marker)
      this.map.setCenter(new Coordinate(point))
    },
  },
})
